import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from '../services/auth/AxiosInstance';

export const useGetNotifications = (params = {}) => {
    return useQuery({
        queryKey: ['notifications', params],
        queryFn: async () => {
            const response = await AxiosInstance.get('/notifications', { params });
            return response.data;
        },
        keepPreviousData: true
    });
};

export const useMarkAsRead = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (notificationId) => {
            const response = await AxiosInstance.patch(`/notifications/${notificationId}/read`);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['notifications']);
        }
    });
};

export const useMarkAllAsRead = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            const response = await AxiosInstance.patch('/notifications/read-all');
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['notifications']);
        }
    });
};

export const useDeleteNotification = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (notificationId) => {
            const response = await AxiosInstance.delete(`/notifications/${notificationId}`);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['notifications']);
        }
    });
};
